import { useEffect, useState } from "react";
import {
  isSignInWithEmailLink,
  onAuthStateChanged,
  signInWithEmailLink,
  signOut,
} from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase";
import "./team.css";
export default function AcceptInvitation() {
  const [email, setEmail] = useState(""),
    [user, setUser] = useState(null),
    [ready, setReady] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [done, setDone] = useState(false),
    [acceptedClinic, setAcceptedClinic] = useState("");
  useEffect(
    () =>
      onAuthStateChanged(auth, (value) => {
        setUser(value);
        setReady(true);
      }),
    [],
  );
  async function accept(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      if (isSignInWithEmailLink(auth, window.location.href))
        await signInWithEmailLink(
          auth,
          email.trim().toLowerCase(),
          window.location.href,
        );
      else if (!auth.currentUser)
        throw new Error(
          "Abre el enlace completo que recibiste por correo para verificar tu cuenta.",
        );
      const params = new URLSearchParams(window.location.search);
      const accepted = await httpsCallable(
        functions,
        "acceptClinicInvitation",
      )({
        clinicId: params.get("clinic"),
        invitationId: params.get("invitation"),
        token: params.get("token"),
      });
      setAcceptedClinic(accepted.data.clinicId || params.get("clinic"));
      window.history.replaceState({}, "", "/invitacion");
      setDone(true);
    } catch (caught) {
      setError(
        caught.code?.startsWith("auth/")
          ? "El enlace no es válido para ese correo o ya venció. Revisa el correo al que llegó o solicita una nueva invitación."
          : caught.message || "No se pudo aceptar la invitación.",
      );
    } finally {
      setBusy(false);
    }
  }
  const emailLink = isSignInWithEmailLink(auth, window.location.href);
  return (
    <main
      className="clinic-team"
      style={{ maxWidth: 550, margin: "8vh auto", padding: 24 }}
    >
      <h1>VexaDent</h1>
      <h2>{done ? "Ya eres parte del equipo" : "Invitación al consultorio"}</h2>
      {done ? (
        <>
          <p>
            Tu acceso quedó activado. Los permisos se aplican únicamente a este
            consultorio.
          </p>
          <a
            className="team-button team-primary"
            href={"/?consultorio=" + encodeURIComponent(acceptedClinic)}
          >
            Entrar a VexaDent
          </a>
        </>
      ) : (
        <form onSubmit={accept}>
          <p>
            Confirma el correo al que llegó la invitación para activar tu
            acceso.
          </p>
          {error && (
            <div className="team-error" role="alert">
              {error}
            </div>
          )}
          {emailLink ? (
            <label>
              Correo de la invitación
              <input
                style={{
                  display: "block",
                  width: "100%",
                  padding: 12,
                  margin: "12px 0",
                }}
                type="email"
                autoComplete="email"
                required
                maxLength={254}
                value={email}
                disabled={busy}
                onChange={(event) => setEmail(event.target.value)}
              />
            </label>
          ) : user ? (
            <>
              <p>Sesión actual: {user.email}</p>
              <button
                type="button"
                className="team-button"
                disabled={busy}
                onClick={() => signOut(auth)}
              >
                Cambiar cuenta
              </button>
            </>
          ) : (
            <p>Para continuar, abre el enlace del correo de invitación.</p>
          )}
          <button
            style={{ marginTop: 16 }}
            className="team-button team-primary"
            disabled={!ready || busy || (!emailLink && !user)}
          >
            {busy ? "Activando acceso…" : "Aceptar invitación"}
          </button>
          <p className="team-help">
            Si el correo corresponde a otra cuenta, solicita al administrador
            una invitación para tu correo.
          </p>
        </form>
      )}
    </main>
  );
}
